import React, {useState, useEffect, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useLocation} from 'react-router-dom';
import {history, url} from '../../utils/variables';
import {firstBoot, setInsuranceCode, setUserAction} from '../../redux/actions';
import Notifications from '../../components/pages/home/Notifications';
import HomeButton from '../../components/pages/home/Button';
import Switch from '../../components/master/Switch';
import { useTranslation } from 'react-i18next';
import Modal from '../../components/master/Modal';
import logo from '../../assets/images/logo.png'
import alarm from '../../assets/images/alarm.gif';
import bell from '../../assets/images/bell.png';
import { getQueryString, pexios } from '../../utils/functions';
import FingerPrint from '../../assets/images/fingerPrint.gif';
import Balon from '../../assets/images/ballon.png'
import FireBalon from '../../assets/images/gifs/fireBalloon00.gif'
import FixedBalon from '../../assets/images/gifs/fixedBalloon00.gif'

export default function Home() {
    const { t, i18n } = useTranslation();
    const location = useLocation();

    const dispatch = useDispatch();
    const queryString = location.search && location.search.split("&")
    const insuranceLogo = queryString[0]?.replace('?', '');
    const action = queryString[1]?.split('=')[1] || ''
    // const insuranceLogo = location.search && location.search.replace('?', '');

    const { boot, user , language ,theme ,insuranceCode,userAction} = useSelector(store => store);

    const [openalert ,setOpenAlert] = useState(false);
    const [shebaAlert ,setShebaAlert] = useState(false);
    const [popup , setPopup] = useState([]);

    const firstLogin = getQueryString('login');
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isPaused, setIsPaused] = useState(!firstLogin);
    // const ballons = {
    //     'user': [{src:FireBalon},{src:FireBalon}],
    //     'expert' : [{src:FireBalon},{src:FireBalon}]
    // }
    const [ballons , setBallons] = useState(user.type === 'user' ? [{src:Balon},{src:Balon},{src:Balon}]:[{src:Balon},{src:Balon}])
    const length = ballons.length;
    const slider = useRef(null)
    const [isMouseDown,setIsMouseDown] = useState(false)
    const [startX,setStartX] = useState(0)
    const [ scrollLeft , setScrollLeft] = useState(0)
    const [rotation, setRotation] = useState(0);
    const [previousState,setPreviousState] = useState(0)
    const [isMovingUp,setIsMovingup] = useState(false)
    const [buttonDisabled ,setButtonDisabled] = useState(firstLogin)
    const ballonWidth = 300
    useEffect(() => {
        const interval = setInterval(() => {
            if (!isPaused) {
            setCurrentIndex((prevIndex) => {
                if(prevIndex === ballons.length -1){
                    setIsPaused(true)
                    setButtonDisabled(false)
                }
                slider.current.style.transform = `translateX(-${((prevIndex+1)%length) * ballonWidth}px)`
                setPreviousState(prevIndex)
                return (prevIndex + 1) % length
            });
            }
        }, 1000);
        return () => clearInterval(interval);
      }, [isPaused,currentIndex]);
     
      const nextItem = () => {
        setCurrentIndex((prevIndex) => {
            slider.current.style.transform = `translateX(-${((prevIndex+1)%length) * ballonWidth}px)`
            setPreviousState(prevIndex)
            return (prevIndex + 1) % length
        });
      };
    
      const prevItem = () => {
        setCurrentIndex((prevIndex) => {
            slider.current.style.transform = `translateX(-${((prevIndex-1)%length) * ballonWidth}px)`
            setPreviousState(prevIndex)
            return (prevIndex - 1) % length
        });
      };

    useEffect(() => {
        action && dispatch(setUserAction(action));
        i18n.changeLanguage(language.lang || "fa");
        const isApplication = location.search;
        if (!boot && isApplication) {
            dispatch(firstBoot(true));
        } else if (!boot && !isApplication) {
			dispatch(firstBoot(true));
			if(insuranceLogo && !insuranceLogo.includes('login')) {
                const insuranceCode = insuranceLogo.split(".")[0]
                dispatch(setInsuranceCode(insuranceCode))
                history.replace(`/login?${insuranceLogo}`)
            }else {
                history.replace('/login');
            }
		}
        else if (user.type) {
            if(user.type === 'user' && userAction) {
                if(userAction === 'request_accident') history.push('/accident-type');
                if(userAction === 'request_register') history.push('/register');
            }
            if(user.type === 'expert'){
                // firstLogin && ((user?.data?.company === 0 || user?.data?.company > 28) && (!user.sheba || user.sheba.length !== 24)) && setShebaAlert(true)
                // pexios('api/show-popup')
                //  .then((res)=>{
                //     if(res.data.type !== 'off'){
                //         setOpenAlert(true)                  
                //         setPopup(res.data)
                //     } 
                // })
            }
        } else {
            if(insuranceLogo && !insuranceLogo.includes('login')) {
                const insuranceCode = insuranceLogo.split(".")[0]
                dispatch(setInsuranceCode(insuranceCode))
                history.replace(`/login?${insuranceLogo}`)
            }else {
                history.replace('/login');
            }
        }
    }, [boot, user, location.search, dispatch,language]);
    function closeAlert() {
        setOpenAlert(false)
        pexios('api/see-popup')
    }
    const [prevVal ,setPrevVal] = useState(0)
    function scrollHandle(e) {
        const carousel = slider.current
        const slide = carousel.getElementsByClassName(`slide-0`)[0]
        const currentSlide = carousel.getElementsByClassName(`slide-${currentIndex}`)[0]
        const value = Math.abs(slide.getBoundingClientRect().left/ballonWidth)
        // console.log(carousel.getBoundingClientRect().left/ballonWidth)
        const value2 = carousel.getBoundingClientRect().left/ballonWidth;
        if(prevVal > value2){
            if(value2 > -0.2) {
                setCurrentIndex(0)
            }else if(value2 < -.2 && value2 > -1.2) {
                setCurrentIndex(1)
            }else if(value2 < -1.2 ) {
                setCurrentIndex(2)
            }
            setPrevVal(value2)
        }else {
            if(value2 > -0.4) {
                setCurrentIndex(0)
            }else if(value2 < -.4 && value2 > -1.4) {
                setCurrentIndex(1)
            }else if(value2 < -1.4) {
                setCurrentIndex(2)
            }
            setPrevVal(value2)
        }
        // console.log(carousel.getElementsByClassName(`slide-${currentIndex}`)[0].getBoundingClientRect().left/300)
        // value < .4 ? setCurrentIndex((prevState)=> {setPreviousState(prevState); return 0} ) : setCurrentIndex((prevState)=> {setPreviousState(prevState); return Math.ceil(value)})
        // const rotationx = parseInt(carousel.getBoundingClientRect().left - carousel.offsetLeft)/300
        // console.log(rotationx)
        // if(previousState > currentIndex){///slide to left
            // if((rotationx < -0.2 && rotationx > -.5)||(rotationx < -1.2 && rotationx > -1.5) || (rotationx < -2.2 && rotationx > -2.5) ){
            //     // setRotation(Math.max(rotationx,(-1*(rotationx+(30*currentIndex)))))
            //     setRotation(-20)
            // }
            // else{
            //     setRotation(0)
            // }
        //     setTimeout(()=>setRotation(0),300)
        // }else {
        //     // if((rotationx < -10 && rotationx > -30)||(rotationx < -20 && rotationx > -60) || (rotationx < -50 && rotationx > -90) ){
        //         // setRotation(Math.max(rotationx,(-1*(rotationx+30))))
        //         setRotation(15)
        //     // }else  {
        //     //     setRotation(0)
        //     // }
        //     setTimeout(()=>setRotation(0),300)
        // }
        // else if(rotationx < -30 && rotationx > -60){
        //     setRotation(Math.max(rotationx-45,rotationx-30))
        // }else if(rotationx < -60 && rotationx > -90){
        //     setRotation(Math.max(rotationx-75,rotationx-60))
        // }
        // slide.style.transform = `rotate(${Math.max(rotation-15,rotation)}deg)`
        
        // if(Math.ceil(currentSlide.getBoundingClientRect().left) === carousel.offsetLeft){
        //     currentSlide.style.transform = `rotate(0deg)`
        // }
        // else if(parseInt(currentSlide.getBoundingClientRect().left) < carousel.offsetLeft) {
        //     //slide to left
        //     // const rotation = (parseInt(carousel.getBoundingClientRect().left)/300- carousel.offsetLeft)
        //     currentSlide.style.transform = `rotate(${Math.min(rotation,-20)}deg)`
        // }else {
        //     //slide to right
        //     // const rotation = (parseInt(carousel.getBoundingClientRect().left)/300- carousel.offsetLeft)
        //     currentSlide.style.transform = `rotate(-${Math.min(rotation,-20)}deg)`
        // }
    }
    return (
        <>
            {insuranceCode?
                <div 
                    className={`background-image`}
                    style={{backgroundImage:`url('${url}/images/insurances/app-flag/${insuranceCode}_city${theme ==='dark' ? '1':'2'}.png')`}}>
                </div>
            :
                <div className={`background-image background-${theme}`}/>
            }
            <div className={`cloud cloud2 cloud-${theme}`}/>
            <div className={`cloud cloud1 cloud-${theme}`}/>
            <div className={`cloud cloud3 cloud-${theme}`}/>
            <div className='d-flex flex-column flex1 home '>
                {openalert && 
                <Modal visible={openalert}>
                    {/* <div className='alert-box p10'>                        
                        <span className='alert-icon'><i className='fas fa-bell'/></span>
                        <span className='close-btn'><i className='fas fa-times'/></span>
                        <p className='alert-title'>اطلاعیه جدید</p>
                        <img src={logo}/>
                        <p className='alert-text mt20 p10'>شرکت ارزیابی خسارت بالن فعال در زمینه کارشناسی و ارزیابی خسارت بیمه با رویکرد طرح های نوین و بی سابقه در کشور، مفتخر است تا با ارائه اولین سیستم تمام آنلاین اعلام و ارزیابی خسارت مالی و جانی بیمه ای (وب سایت و اپلیکیشن) در کشور عزیزمان، گامی مهم در جهت تسریع ارائه خدمات بیمه ای به هم میهنان عزیز بردارد</p>
                        <button className='btn btn-block btn-circle btn-green m10' onClick={()=> setOpenAlert(false)}>متوجه شدم</button>
                    </div> */}
                    {/* <div className='alert-box2'>
                        <span className='alert-icon mt20 mb20'>
                            <i className='fas fa-bell'/>
                            <img src={bell} style={{width : '25px'}} />
                            </span>
                        <div className='upper-card pt40 pb20'>
                        <span className='close-btn'><i className='fas fa-times'/></span>
                            
                        <img src={logo}/>
                        </div>
                    <p className='alert-text mt20 p20'>
                    شرکت ارزیابی خسارت بالن فعال در زمینه کارشناسی و ارزیابی خسارت بیمه با رویکرد طرح های نوین و بی سابقه در کشور، مفتخر است تا با ارائه اولین سیستم تمام آنلاین اعلام و ارزیابی خسارت مالی و جانی بیمه ای (وب سایت و اپلیکیشن) در کشور عزیزمان، گامی مهم در جهت تسریع ارائه خدمات بیمه ای به هم میهنان عزیز بردارد</p>
                    <div className='body-card m10'>
                        <button className='btn btn-block btn-circle m10' onClick={()=> setOpenAlert(false)}>متوجه شدم</button>
                        </div>
                    </div> */}
                    <div className='alert-box3'>
                        {popup.type === 'image' && 
                            <img className='alert-image' src ={`${url}/${popup.pop.address}`} alt="popup image"/>
                        }
                        {popup.type === 'text' &&
                        <div className='upper-card'>
                            <img className='mt20 alert-icon' src={alarm} alt="alert icon"/>                            
                            <p className='alert-text mt10 p15'>
                                {popup.pop.text}</p>
                        </div>
                            }
                        <div className='footer-card'>
                            <button className='btn btn-block btn-circle m15' onClick={closeAlert}>{popup.type === 'image' ? t('Close') : t('Get it')}</button>
                        </div>
                    </div>
                </Modal> }
                {/* {shebaAlert &&
                    <Modal visible={shebaAlert}>
                        <div className="modal-content text-justify p20" style={{maxWidth:'70%'}}>
                            <p className='text-justify my10'>کارشناس گرامی؛ لطفا از قسمت ویرایش پروفایل اقدام به تکمیل یا اصلاح شماره شبای خود نمایید</p>
                            <div className='d-flex flex-column justify-center mt30'>
                                <button className='btn btn-block btn-circle btn-white-purple my10' 
                                    onClick={()=>{
                                        setShebaAlert(false)
                                        history.push('/edit-profile')
                                    }}
                                    >رفتن به ویرایش پروفایل</button>
                                    <button className='btn btn-block btn-circle btn-orange my10' 
                                    onClick={()=>setShebaAlert(false)}
                                    >بعدا اصلاحش میکنم</button>
                            </div>
                        </div>
                    </Modal>
                } */}
                {/* {user.type === 'user' &&
                <div className='flex1'>
                    {
                        user.type === 'user' &&
                        <Switch
                            value={userType}
                            labels={[
                                t('I am culprit'),
                                t('I am losses'),
                            ]}
                            values={[
                                'culprit',
                                'losses',
                            ]}
                            onChange={(value) => setUserType(value)}
                            type="userType"
                        />
                    }
                </div>
} */}
                <div className='carousel' id="carousel" onScroll={(e)=> scrollHandle(e)}
                    // onMouseDown={handleMouseDown}
                    // onMouseUp={handleMouseUp}
                    // onMouseLeave={handleMouseLeave}
                    // onMouseMove={handleMouseMove}
                    >
                    <button className="carousel-button prev" disabled={currentIndex === 0} onClick={prevItem}>❮</button>
                    <button className="carousel-button next" disabled={currentIndex === length-1} onClick={nextItem}>❯</button>
                    <div 
                        className='slider' 
                        ref={slider}
                        // style={{ transform: `translateX(-${currentIndex * 300}px)`}}
                        >
                    {/* {isPaused && items.map((item,index)=>(
                        <div 
                            className={`slide slide-${index} ${currentIndex === index ? 'active' : currentIndex > index ? 'slide-to-left' : 'slide-to-right'} ${(currentIndex === index && isMovingUp) ? 'moving-up' : ''}`} 
                            key={index}    
                            style={{transform: `rotate(${rotation}deg)`}}                        
                            // style={{ transform: `translateX(-${currentIndex * 100}%)`}}
                        >
                            <img src={item.src} alt="balon1"/>
                        </div>
                    ))} */}
                    {
                    // !isPaused && 
                    ballons.map((item,index)=>(
                        <div 
                            className={`slide slide-${index} 
                                        ${currentIndex === index ? 'active' : currentIndex > index ? 'slide-to-left' : 'slide-to-right'} 
                                        ${(currentIndex === index && isMovingUp) ? 'moving-up' : ''}`}   
                            key={index}    
                            // style={{transform: `rotate(${rotation}deg)`}}                        
                            // style={{ transform: `translateX(-${currentIndex * 100}%)`}}
                        >
                            {insuranceCode ?
                            <img className='fire-balon' src={`${url}/images/insurances/app-flag/${insuranceCode}_home.gif`} alt="balon1"/>
                            :
                            <>
                            <img style={{display : `${isMovingUp? 'block':'none'}`}} className='fire-balon' src={FixedBalon} alt="balon1"/>
                            <img style={{display : `${!isMovingUp? 'block':'none'}`}} className='fire-balon' src={FireBalon} alt="balon1"/>
                            {/* {isMovingUp ? <img className='fire-balon' src={FireBalon} alt="balon1"/>: <img className='fire-balon' src={item.src} alt="balon1"/>} */}
                            </>
                            }
                            </div>
                    ))
                }
                    </div>
                </div>
                {/* <div className='mainButton'>
                    <HomeButton userType={userType}/>
                </div> */}
                <div className='homeButtonParent'>
                    <div className='homeButton'>
                        <HomeButton currentIndex={currentIndex}  handleMoving={(moving)=>setIsMovingup(moving)} disabled={buttonDisabled}/>
                    </div>
                </div>
                {/* <div className='home-cards'>
                    <Link className='list-box d-flex' to='/report-list'>
                        <p>پرونده های من </p>
                        <img src={ListOutline} alt="my cases"/>
                        {user.type === 'user' && <span className='badge'>{fileCount}</span>}
                    </Link>
                    <div>
                        <Notifications/>
                    </div>
                    <Link className='list-box d-flex' to='edit-profile' >
                        <p>  ویرایش پروفایل </p>
                        <img src={EditProfileOutline} alt="edit profile"/>
                    </Link>
                </div> */}
                <div className='flex1'/>

            </div>
            </>
            
    )

}
